/** Customer Link B validity window (days from send or renewal). */
export const LINK_B_VALIDITY_DAYS = 14;

export function computeLinkBExpiresAt(from: Date = new Date()): Date {
  const d = new Date(from);
  d.setDate(d.getDate() + LINK_B_VALIDITY_DAYS);
  return d;
}

export function resolveLinkBExpiresAt(header: {
  linkBExpiresAt?: Date | string | null;
  sentAt?: Date | string | null;
}): Date | null {
  if (header.linkBExpiresAt) {
    const parsed = new Date(header.linkBExpiresAt);
    return Number.isFinite(parsed.getTime()) ? parsed : null;
  }
  return null;
}

/** True when Link B time window has passed (ignores approval — use isLinkBAccessBlocked for gating). */
export function isLinkBPastExpiry(header: {
  linkBExpiresAt?: Date | string | null;
  sentAt?: Date | string | null;
}): boolean {
  const expiresAt = resolveLinkBExpiresAt(header);
  if (!expiresAt) return false;
  return expiresAt.getTime() < Date.now();
}

/**
 * Block customer Link B when cancelled, or sent-but-not-approved past expiry.
 * Approved proposals remain accessible regardless of expiry date.
 */
export function isLinkBAccessBlocked(header: {
  linkBExpiresAt?: Date | string | null;
  sentAt?: Date | string | null;
  cancelledAt?: Date | string | null;
  status?: string | null;
  approvedAt?: Date | string | null;
}): boolean {
  if (header.cancelledAt) return true;
  const status = String(header.status ?? "").toLowerCase();
  if (status === "approved" || header.approvedAt) return false;
  return isLinkBPastExpiry(header);
}

export function formatLinkBExpiryLabel(date: Date | string | null | undefined): string {
  if (!date) return "—";
  const d = new Date(date);
  if (!Number.isFinite(d.getTime())) return "—";
  return d.toLocaleDateString("en-SG", { day: "numeric", month: "short", year: "numeric", timeZone: "Asia/Singapore" });
}

export function formatLinkBExpiryLongLabel(date: Date | string | null | undefined): string {
  if (!date) return "the stored Link B expiry date";
  const d = new Date(date);
  if (!Number.isFinite(d.getTime())) return "the stored Link B expiry date";
  return d.toLocaleDateString("en-SG", {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "Asia/Singapore",
  });
}
